import { EcoaContent } from "@components/common/EconContent";
import React from "react";
import { Footer } from "@layouts/Footer";
import { useLangContext } from "@layouts/home/LangContext";
import { HbButton } from "@maven-surface/components/base/HbButton";
import { HbParagraph } from "@maven-surface/components/base/HbParagraph";
import { useRoute } from "@maven-surface/hooks/useRoute";
import { COMMON_LANG } from "@maven-msg/lang/common";
import { ECOA_CAPTURE_LANG } from "@maven-msg/lang/ecoaCapture";
import { MvnMessage } from "@maven-msg/lib/Message";

interface VisitQuestionnaireDoneProps {
  folderId: string;
  visitId: string;
  visitSeq: number;
}

export function VisitQuestionnaireDone({ folderId, visitId, visitSeq }: VisitQuestionnaireDoneProps) {
  const { pushPath, query } = useRoute();

  const { fontSize } = useLangContext();

  const titleSize = fontSize === "LARGE" ? "5X-LARGE" : fontSize === "MEDIUM" ? "3X-LARGE" : "X-LARGE";
  const descriptionSize = fontSize === "LARGE" ? "4X-LARGE" : fontSize === "MEDIUM" ? "2X-LARGE" : undefined;
  const buttonSize = fontSize === "LARGE" ? "4X-LARGE" : fontSize === "MEDIUM" ? "2X-LARGE" : undefined;

  return (
    <>
      <EcoaContent>
        <HbParagraph
          text={MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_SUBMIT_SUCC_TITLE)}
          align="CENTER"
          color="PRIMARY"
          bold={true}
          size={titleSize}
        />
        <HbParagraph
          text={MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_SUBMIT_SUCC_DESCRIPTION)}
          spacing={2}
          margin={1}
          align="CENTER"
          color="GRAY"
          size={descriptionSize}
        />
      </EcoaContent>
      <Footer>
        <HbButton
          onClick={() => {
            pushPath(query.from === "crfs" ? `/pat/crfs/${folderId}/${visitId}/${visitSeq}` : "/pat/visits");
          }}
          text={MvnMessage(COMMON_LANG.CONFIRM_ALTER)}
          size={buttonSize}
        />
      </Footer>
    </>
  );
}
